module.exports = __webpack_public_path__ + "img/hr-dry-hairy-tree-04.056fc124.png";